// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LocaleRouteImport } from './routes/$locale'
import { Route as MaintenanceRouteImport } from './routes/maintenance'
import { Route as LocaleIndexRouteImport } from './routes/$locale/index'
import { Route as LocaleContactRouteImport } from './routes/$locale/contact'
import { Route as LocaleMapRouteImport } from './routes/$locale/map'
import { Route as LocaleOfferRouteImport } from './routes/$locale/offer'
import { Route as LocaleOfferSelectRouteImport } from './routes/$locale/offer_.select'
import { Route as LocaleQuestionSlugRouteImport } from './routes/$locale/question/$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LocaleRoute = LocaleRouteImport.update({
            id: '/$locale',path: '/$locale',getParentRoute: () => rootRouteImport
          })
const MaintenanceRoute = MaintenanceRouteImport.update({
            id: '/maintenance',path: '/maintenance',getParentRoute: () => rootRouteImport
          })
const LocaleIndexRoute = LocaleIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LocaleRoute
          })
const LocaleContactRoute = LocaleContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => LocaleRoute
          })
const LocaleMapRoute = LocaleMapRouteImport.update({
            id: '/map',path: '/map',getParentRoute: () => LocaleRoute
          })
const LocaleOfferRoute = LocaleOfferRouteImport.update({
            id: '/offer',path: '/offer',getParentRoute: () => LocaleRoute
          })
const LocaleOfferSelectRoute = LocaleOfferSelectRouteImport.update({
            id: '/offer_/select',path: '/offer/select',getParentRoute: () => LocaleRoute
          })
const LocaleQuestionSlugRoute = LocaleQuestionSlugRouteImport.update({
            id: '/question/$slug',path: '/question/$slug',getParentRoute: () => LocaleRoute
          })





const LocaleRouteChildren = {
  LocaleContactRoute: LocaleContactRoute,LocaleMapRoute: LocaleMapRoute,LocaleOfferRoute: LocaleOfferRoute,LocaleIndexRoute: LocaleIndexRoute,LocaleOfferSelectRoute: LocaleOfferSelectRoute,LocaleQuestionSlugRoute: LocaleQuestionSlugRoute
}

const LocaleRouteWithChildren = LocaleRoute._addFileChildren(LocaleRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,LocaleRoute: LocaleRouteWithChildren,MaintenanceRoute: MaintenanceRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)